import React from "react";
import PropTypes from "prop-types";
import NumericTextBox from "./NumericTextBox";
import "./UnitNumericTextBox.scss";

/**
 * Unit numeric text box component
 * @module
 * @param {string} name - Name
 * @param {func} onChange - Function invoked on value change
 * @param {number} [value] - Current value
 * @param {bool} [required] - Is input required?
 * @param {bool} [disabled] - Is input readonly?
 * @param {string} [validationMessage] - Validation message if field is invalid
 * @param {number} [min] - Minimum number
 * @param {number} [max] - Maximum number
 * @param {number} [step] - Step
 * @param {(string | object)} [format] - Format
 * @param {bool} [autofocus] - Should input be focused?
 * @param {func} [onBlur] - Function invoked on input blur
 * @param {number} [tabIndex] - NumericTextBox Tabindex
 */

const UnitNumericTextBox = (props) => {
  const element = (
    <div className={`form-input unit-numeric-input ${props.disabled ? "disabled-field" : props.required ? "required-field" : "default-field"} ${props.className ? props.className : ""}`}>
      <NumericTextBox
        name={props.name}
        onChange={props.onChange}
        value={props.value}
        required={props.required}
        validationMessage={props.validationMessage}
        disabled={props.disabled}
        min={props.min}
        max={props.max}
        step={props.step}
        format={props.format}
        tabIndex={props.tabIndex}
        autofocus={props.autofocus}
        onBlur={props.onBlur}
        spinners={props.spinners}
      />
      <div className="unit">
        <span>{props.unit}</span>
      </div>
      {props.tooltip && <div className={"detail-tooltip"}>{props.tooltip}</div>}
    </div>
  );

  return props.notUi ? (
    element
  ) : (
    <div title={props.tooltip}
      className={`k-form-field ${props.required ? "required" : ""} ${props.disabled ? "disabled" : ""} form-unitnumeric ui-field form-field-${props.name}`}
    >
      <span className="detail-label">{props.title}</span>
      {element}
    </div>
  );
};

UnitNumericTextBox.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  validationMessage: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  format: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  autofocus: PropTypes.bool,
  onBlur: PropTypes.func,
  tabIndex: PropTypes.number,
  title: PropTypes.string,
  unit: PropTypes.string,
  spinners: PropTypes.bool,
  tooltip: PropTypes.string,
  notUi: PropTypes.bool,
};

export default UnitNumericTextBox;
